module.exports = __webpack_public_path__ + "static/media/form_builder_empty_state.76ea155d.png";